import React, { useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import { Input } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { GET_LANGUAGES_PAGINATED } from "graphql/query/language-gql";
import Language from "components/language";
import Settings from "components/settings";
import { PageWrapDefault, Tables } from "components/layout";
import { Localize } from "components/service";
import { useActiveMenuItem, useBreadCrumbs } from "components/use-hooks";


const { Search } = Input;
const basePath = Language.Const.basePath;
const tableHelper = Language.Helpers.TableMain;

const LanguagesPage = () => {

    useActiveMenuItem([ "settings-languages" ], [ "settings" ]);

    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_Settings" }).props.children,
            path: `${ Settings.Const.basePath }`
        },
        {
            label: Localize({ children: "BREADCRUMBS.Label_Languages" }).props.children,
            path: `${ basePath }`
        }
    ];

    useBreadCrumbs(breadcrumbs);

    const match = useRouteMatch(`${ basePath }/page/:pageNum`);
    const [ searchText, setSearchText ] = useState("");

    return (
        <PageWrapDefault
            className="page-settings page-languages"
            dataExist={ true }
            title={ <Localize>PAGES.Title_Languages</Localize> }
            staticPath={ `${ basePath }` }
        >
            <Tables.Main
                model="languagesPaginated"
                query={ GET_LANGUAGES_PAGINATED }
                varSet={ { perPage: 30 } }
                routeUrl={ `${ basePath }` }
                currentPage={ match ? parseInt(match.params.pageNum) : 1 }
                searchText={ searchText }
                objFilter={ {} }
                objOrderBy={ [ { column: "LABEL", order: "ASC" } ] }
                tableHelper={ tableHelper }
            >
                <div className="table-action-bar">
                    <div className="col">
                        <Search
                            className="filter-search"
                            prefix={ <SearchOutlined /> }
                            placeholder={ Localize({ children: "SEARCH.Input_Placeholder_Languages" }).props.children }
                            onChange={ (e) => setSearchText(e.target.value) }
                        />
                    </div>

                    <div className="col">
                        <Link
                            className="ant-btn ant-btn-primary"
                            type="primary"
                            to={ `${ basePath }/create` }
                        >
                            <PlusOutlined /> <span><Localize>LANGUAGE.Button_Text_Create</Localize></span>
                        </Link>
                    </div>
                </div>
            </Tables.Main>
        </PageWrapDefault>
    );
};

export default LanguagesPage;
